import {
  Image,
} from './branchInterface';

export interface IDeglawyTrophyStore {
  delawyTrophiesList: DeglawyTrophy[];
  selectedDelawyTrophy: DeglawyTrophy;
  loading: boolean;

  getDelawyTrophies(langCode?: string): Promise<void>;

  getDelawyTrophyById(id: number, langCode?: string): Promise<void> ;

  createDelawyTrophy(newDelawyTrophy: DeglawyTrophy, langCode?: string): Promise<void | string>;

  updateDelawyTrophy(updatedDelawyTrophy: DeglawyTrophy, id: number, langCode?: string): Promise<void | string>;

  updateDeglawyTrophyStatus(updatedDelawyTrophyStatus: boolean, index: number): Promise<void | string>;
}

export class DeglawyTrophy {
  id: number;

  points: number;

  title: string;

  activeImage: (Image | File)[];

  dimmedImage: (Image | File)[];

  isActive: boolean;

  constructor() {
    this.id = 0;
    this.points = 0;
    this.title = '';
    this.activeImage = [];
    this.dimmedImage = [];
    this.isActive = false;
  }

  setId(id: number): void {
    this.id = id;
  }

  getId(): number {
    return this.id;
  }

  setPoints(points: number): void {
    this.points = points;
  }

  getPoints(): number {
    return this.points;
  }

  getTitle(): string {
    return this.title;
  }

  setTitle(title: string): void {
    this.title = title;
  }

  getActiveImage(): (Image | File)[] {
    return this.activeImage;
  }

  setActiveImage(activeImage: (Image | File)[]): void {
    this.activeImage = activeImage;
  }

  getDimmedImage(): (Image | File)[] {
    return this.dimmedImage;
  }

  setDimmedImage(dimmedImage: (Image | File)[]): void {
    this.dimmedImage = dimmedImage;
  }

  getIsActive(): boolean {
    return this.isActive;
  }

  setIsActive(isActive: boolean): void {
    this.isActive = isActive;
  }

  getTrophy(): { id: number; isActive: boolean; points: number; title: string; activeImage: (Image | File)[]; dimmedImage: (Image | File)[] } {
    return {
      id: this.id,
      points: this.points,
      isActive: this.isActive,
      title: this.title,
      activeImage: this.activeImage,
      dimmedImage: this.dimmedImage,
    };
  }

  getTrophyExceptId(): { points: number; isActive: boolean; title: string; activeImage: (Image | File)[]; dimmedImage: (Image | File)[] } {
    return {
      points: this.points,
      isActive: this.isActive,
      title: this.title,
      activeImage: this.activeImage,
      dimmedImage: this.dimmedImage,
    };
  }

  getTrophyToCreate(): { points: number; title: string; activeImageURL: string | null; dimmedImageURL: string | null } {
    return {
      points: this.points,
      title: this.title,
      activeImageURL: (this.activeImage && this.activeImage.length ? this.getImageURL(this.activeImage[0]) : null),
      dimmedImageURL: (this.dimmedImage && this.dimmedImage.length ? this.getImageURL(this.dimmedImage[0]) : null),
    };
  }

  getTrophyToUpdate(): { points: number; title: string; activeImageURL: string | null; dimmedImageURL: string | null } {
    return {
      points: this.points,
      title: this.title,
      activeImageURL: (this.activeImage && this.activeImage.length ? this.getImageURL(this.activeImage[0]) : null),
      dimmedImageURL: (this.dimmedImage && this.dimmedImage.length ? this.getImageURL(this.dimmedImage[0]) : null),
    };
  }

  private getImageURL(image: (Image | File)): string | null {
    if (image && this.isImage(image)) {
      return image.imageUrl;
    }
    return null;
  }

  private isImage(image: any): image is Image {
    return 'imageUrl' in image;
  }
}
